import api from "../../index";

export const VerifyPasswordApi = (data) => api.post('checkPassword', data);
export const GetAuthDetailsApi = () => api.post('enable2fa');
export const VerifyTFAuthenticationApi = (data) => api.post('verify2fa', data);
export const DisableTFAuthenticationApi = () => api.post('disable2fa');
export const GetSettingsDetailsApi = () => api.post('setting-data');
export const ChangePasswordApi = (data) => api.post('changepassword', data);
export const NotificationSettingApi = (data) => api.post('notify-setting', data);
export const UpdateProfileApi = (data, headers) => api.post('update-profile', data, headers);

export const getSiteSettingsApi = () => api.post('site-setting-details');
export const UpdateSiteSettingsApi = (data) => api.post('updatesitesetting', data);
